import gql from "graphql-tag";
import { entryFragments } from "./entryFragments";
import { manualFragments } from "./manualFragments";

// IMPORTANT: do not prettify this file.
// Some editors remove commas or directives in template strings when "prettifying".
// prettier-ignore
const LIVE_MANUAL_PREVIEW_QUERY = gql`
  query ($id: [QueryArgument], $siteId: [QueryArgument]) {
    globalSets(siteId: $siteId) {
      handle
      ... on customerSupport_GlobalSet {
        localeSupportInfo {
          ... on supportblock_Entry {
            id
            localeTitle
            locality
            phone
            internationalPhone
            email
            addressLine1
            addressLine2
          }
        }
      }
      ... on translations_GlobalSet {
        translationKeyValuePairs {
          labelKey
          labelValue
        }
      }
    }

    glossary: entries(section: "glossary", siteId: $siteId) {
      ... on glossaryTerm_Entry {
        id
        title
        definition { rawHtml }
      }
    }

    globalVariables: entries(section:"variables", siteId:$siteId, type: ["variable"]) {
      id  # need id only for global variables as they may be overridden by product scoped variables, nested variables are not implemented yet
      ...VariableEntryFields
    }

    entry(id: $id, siteId: $siteId) {
      id
      siteId
      language
      typeHandle

      # If it's a product
      ... on product_Entry {
        ...ProductEntryFields
      }

      # If it has children that are chapter_Entries
      children {
        id
        ... on chapter_Entry {
          ...ChapterEntryFields
        }
      }

      # If the top-level entry itself can be a chapter_Entry:
      ... on chapter_Entry {
        ...ChapterEntryFields
      }
    }
  }

  # Spread the imported fragments so GraphQL is aware of them.
  # You only need to include the "top-level" fragments here.
  # The rest will chain because they're nested inside each other.
  ${entryFragments}

  ${manualFragments}
`;

export default LIVE_MANUAL_PREVIEW_QUERY;